import { useCallback, useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

type ChatFormProps = {
  disabled?: boolean;
  onSend: (text: string) => void;
};

export default function ChatForm({ disabled, onSend }: ChatFormProps) {
  const [value, setValue] = useState('');

  const submit = useCallback(() => {
    const q = value.trim();
    if (!q || disabled) return;
    onSend(q);
    setValue('');
  }, [value, disabled, onSend]);

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <Box sx={{ px: 1.5, pb: 1.5, pt: 0.5 }}>
      <TextField
        fullWidth
        multiline
        minRows={3}
        maxRows={6}
        placeholder="Type your message"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={disabled}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            fontSize: '12px',
            bgcolor: '#fcfaff',
            '& fieldset': { borderColor: '#e9ddff' },
            '&:hover fieldset': { borderColor: '#cbb4ff' },
            '&.Mui-focused fieldset': {
              borderColor: '#7c3aed',
              borderWidth: 1,
              boxShadow: 'none',
            },
          },
          '& .MuiInputBase-input::placeholder': {
            fontSize: '10px',
            color: '#a78bfa',
            opacity: 1,
          },
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
        <Button
          variant="contained"
          size="small"
          endIcon={<SendIcon sx={{ fontSize: 16 }} />}
          onClick={submit}
          disabled={disabled || !value.trim()}
          sx={{
            minHeight: 34,
            fontSize: '0.78rem',
            fontWeight: 600,
            bgcolor: '#7c3aed',
            boxShadow: 'none',
            '&:hover': { bgcolor: '#6d28d9', boxShadow: 'none' },
          }}
        >
          Send
        </Button>
      </Box>
    </Box>
  );
}
